<template>
  <IconLucideLoaderCircle class="gpx-svg-loading" />
</template>

<style scoped>
.gpx-svg-loading {
  animation: rotate 1.5s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
